import { AlgoliaOffice } from '@caresend/types';
import { getHitsFromAlgoliaSearch, indexOffices } from '@caresend/ui-components';

export const searchOfficesBySlugName = (apiKey: string): Promise<AlgoliaOffice[]> =>
  getHitsFromAlgoliaSearch<AlgoliaOffice>(indexOffices(apiKey), '');
